export default "__VITE_ASSET__FUCqsxsA__"